import { useState } from 'react';
import { useHistory } from '@medlinker/fundamental';
import { getFaceId, queryFaceResult } from '../../apis/faceRecognition';
import { useMount } from 'react-use';
import { useEvent } from './useEvent';
import qs from 'qs';
// import env from '../utils/env';
import { Toast } from '../components';
import useQuery from './useQuery';

// const webankAppId = env.appEnv === 'prod' ? 'IDAwSTzm' : 'TIDAqwpm';
const webankAppId = 'IDAwSTzm';
const version = '1.0.0';

export const useFaceRecognition = () => {
  const history = useHistory();
  const { code, orderNo } = useQuery();
  const [loading, setLoading] = useState(false);
  const [isFaceRecognitionPassed, setIsFaceRecognitionPassed] = useState(false);
  const [hasQueriedFaceRecognitionStatus, setHasQueriedFaceRecognitionStatus] =
    useState(false);

  useMount(() => {
    // 在页面加载后，如果code存在，且orderNo存在，则查询人脸识别结果
    queryFaceRecognitionStatus();
  });

  const shouldQueryFaceRecognitionStatus = code === '0' && !!orderNo;

  /**
   * 查询人脸识别结果
   */
  const queryFaceRecognitionStatus = useEvent(async () => {
    try {
      if (shouldQueryFaceRecognitionStatus) {
        const { pass } = await queryFaceResult().setData({
          orderNo: orderNo as string,
        });

        setIsFaceRecognitionPassed(pass);
      }
    } catch (e) {
      Toast.fail(e.message);
    } finally {
      setHasQueriedFaceRecognitionStatus(true);
    }
  });

  /**
   * 激活人脸识别流程
   */
  const activateFaceRecognition = useEvent(
    async (params: {
      idCardNo: string;
      name: string;
      redirectPath: string;
      redirectQuery?: Record<string, string>;
    }) => {
      const { idCardNo, name, redirectPath, redirectQuery } = params;

      try {
        setLoading(true);

        const res = await getFaceId().setData({
          idNo: idCardNo,
          isPatient: true,
          name: name,
        });

        let { optimalDomain, ...rest } = res;

        if (!optimalDomain.startsWith('http')) {
          optimalDomain = `https://${optimalDomain}`;
        }

        const redirectURL =
          window.location.origin +
          history.createHref({
            pathname: redirectPath,
            search: qs.stringify(redirectQuery, { addQueryPrefix: true }),
          });

        const domain =
          optimalDomain || 'https://miniprogram-kyc.tencentcloudapi.com';
        const url = `${domain}/api/web/login`;
        const queries = qs.stringify(
          {
            webankAppId,
            version,
            // resultType: '2',
            ...rest,
            userId: res.userId.toString(),
            url: redirectURL,
            redirectType: '1',
          },
          { addQueryPrefix: true }
        );

        // https://cloud.tencent.com/document/product/1007/61074
        window.location.href = url + queries;
      } catch (e) {
        Toast.fail(e.message);
      } finally {
        setLoading(false);
      }
    }
  );

  return {
    loading,
    activateFaceRecognition,
    isFaceRecognitionPassed,
    queryFaceRecognitionStatus,
    hasQueriedFaceRecognitionStatus,
    shouldQueryFaceRecognitionStatus,
  };
};
